import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  LocaleKey,
  localeMap,
} from "components/DatePickers/locales.interfaces";
import { format } from "date-fns";
import { CaptionProps, useNavigation } from "react-day-picker";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useConfig } from "@thekilroygroup/shared-ui";

interface ICaptionProps extends CaptionProps {
  changeMonth: (date: Date) => void;
}
export const Caption = (props: ICaptionProps) => {
  const { changeMonth } = props;
  const { goToMonth, nextMonth, previousMonth, currentMonth } = useNavigation();
  const { locale } = useConfig();
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("sm"));

  useEffect(() => {
    changeMonth(currentMonth);
  }, [currentMonth]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey[100]",
      }}
    >
      <IconButton
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Typography variant={"h5"}>
        {format(currentMonth, isMobile ? "MMM yyyy" : "MMMM yyyy", {
          locale: localeMap[locale as LocaleKey],
        })}
      </Typography>
      <IconButton
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}
        size="small"
      >
        <KeyboardArrowRightIcon />
      </IconButton>
    </Box>
  );
};
